import { Outlet } from "@tanstack/react-router";
import TopBar from "@/layouts/AppLayout/TopBar";
import styles from "@/pages/CampaignOverviewPage/page/CampaignOverviewLayout.module.css";

// TopBar (Agency/Advertiser/Campaign breadcrumb + date-range filter + Export)
// is Campaign Overview-specific chrome, not generic app chrome — this layout
// scopes it to just this route's subtree so other pages (e.g. User
// Management) render under AppLayout with no top bar at all. TopBar renders
// full-bleed, outside the padded content area, so it sits flush against the
// sidebar/edges like a real top bar rather than inset like page content.
const CampaignOverviewLayout = () => (
  <>
    <TopBar />
    <div className={styles.content}>
      <Outlet />
    </div>
  </>
);

export default CampaignOverviewLayout;
